"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
var react_1 = __importDefault(require("react"));
var Error_module_scss_1 = __importDefault(require("./Error.module.scss"));
var react_router_dom_1 = require("react-router-dom");
var Error = function (_a) {
    var _b;
    var error = _a.error, resetErrorBoundary = _a.resetErrorBoundary;
    var location = (0, react_router_dom_1.useLocation)();
    var errorMessage = (error === null || error === void 0 ? void 0 : error.message) || ((_b = location.state) === null || _b === void 0 ? void 0 : _b.message) || 'Произошла ошибка';
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement("div", { className: Error_module_scss_1.default.error },
            react_1.default.createElement("h1", { className: Error_module_scss_1.default.error__title }, errorMessage),
            react_1.default.createElement(react_router_dom_1.Link, { className: Error_module_scss_1.default.error__link, to: '/', onClick: resetErrorBoundary }, "\u041D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E \u2192"))));
};
exports.Error = Error;
